import { useCallback, useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useSceneElement } from '@editor/hooks'
import { useEditElementStore } from '@editor/stores'
import RoofDrawing from '../../../RoofDrawing'
import { RoofFormSchema } from '../../schema'

interface Props {
  zComputed: boolean
  element: string
}

const RoofFormScene = ({ zComputed, element }: Props) => {
  const { setValue } = useFormContext()

  const formPoints = useWatch<RoofFormSchema>({ name: 'points' }) as {
    x: number
    y: number
    z: number
  }[]

  const updatePoints = useCallback(
    (points: RoofFormSchema['points']) => {
      setValue('points', points)
    },
    [setValue],
  )

  const activeRoofPointIndex = useEditElementStore(state => state.activeRoofPointIndex)

  const sceneElement = useMemo(
    () => ({
      enabled: true,
      properties: {
        points: formPoints,
        updatePoints,
        activePointIndex: activeRoofPointIndex,
        activeElement: element,
        zComputed,
      },
      component: RoofDrawing,
      // RoofDrawing keeps refs to its edge lines that only a remount resets (e.g. after a
      // corner is removed), so new points re-register it instead of updating it in place
      updateInPlace: false,
    }),
    [formPoints, updatePoints, activeRoofPointIndex, element, zComputed],
  )

  useSceneElement(sceneElement)

  return null
}

export default RoofFormScene
